import {Component, OnInit} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import {TransportesViagensModel} from "./transportes-viagens.model";
import {TransportesViagensService} from './transportes-viagens.service';
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";
import {Global} from "../global";
import {LocaisService} from "../locais/locais.service";
import {TransportesService} from "../transportes/transportes.service";

declare let $:any;

@Component({
  selector: 'app-transportes-viagens-form',
  templateUrl: './transportes-viagens-form.component.html'
})
export class TransportesViagensFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  viagem: TransportesViagensModel = new TransportesViagensModel();
  listTransportes = [];
  listLocais = [];
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private transportesViagensService: TransportesViagensService,
    private locaisService: LocaisService,
    private transportesService: TransportesService,
    private loginService: LoginService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_viagem: [],
      id_transporte: ['', [
        Validators.required
      ]],
      id_local_carregamento: [],
      id_local_descarga: [],
      eta: [],
      data_carregamento: [],
      data_descarga: []
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_viagem'];

      if(this.pageIsUpd){
        this.title = this.func.traduzir('front.editarViagemTransporte');
      }else if(this.pageIsAdd){
        this.title = this.func.traduzir('front.cadastrarViagemTransporte');
        this.viagem.id_transporte = params['id_transporte'];
      }else{
        this.title = this.func.traduzir('front.visualizarViagemTransporte')
      }

      this.locaisService.get()
        .subscribe(
          json => {
            this.listLocais = json.Payload;

            if(this.global.debug == true){
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });

      this.transportesService.get()
        .subscribe(
          json => {
            this.listTransportes = json.Payload;

            if(this.global.debug == true){
              console.log(json.Payload);
            }
          },
          error => {
            this.func.showErro(error.json());
          });

      if (!id) {
        // inicializa pick a date em timeout para nao bugar
        let self = this;
        setTimeout(function () {
          $('.pickadate').pickadate({
            format: 'dd/mm/yyyy',
            formatSubmit: 'yyyy-mm-dd',
            onSet: function(context) {
              self.viagem[this.get('id')] = this._hidden.value;
            }
          });
        },100);

        // cancela carregamento para edição
        return;
      }

      this.transportesViagensService.getById(id)
        .subscribe(
          json => {
            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }

            this.viagem = json.Payload[0];

            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarViagemTransporte')+': '+json.Payload[0].id_viagem;
            }else if(this.pageIsAdd){
              this.title = this.func.traduzir('front.cadastrarViagemTransporte');
            }else{
              this.title = this.func.traduzir('front.visualizarViagemTransporte') + ': ' + json.Payload[0].id_viagem;
            }

            // inicializa pick a date em timeout para nao bugar
            this.loginService.getUserInfo()
              .subscribe(
                res => {
                  let self = this;
                  setTimeout(function () {
                    $('.pickadate').pickadate({
                      format: res.date_format,
                      formatSubmit: 'yyyy-mm-dd',
                      onSet: function(context) {
                        self.viagem[this.get('id')] = this._hidden.value;
                      }
                    });
                  },100);
                },
                error => {
                  this.func.showErro(error.json());
                });

          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,
      values = this.form.value;

    if (values.id_viagem) {
      result = this.transportesViagensService.editar(values, values.id_viagem);
    } else {
      result = this.transportesViagensService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'transportes', values.id_transporte]),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/transportes-viagens/transportes-viagens-form.component.ts